import { render, staticRenderFns } from "./CheckboxRenderer.vue?vue&type=template&id=65c177ca&"
import script from "./CheckboxRenderer.vue?vue&type=script&lang=ts&"
export * from "./CheckboxRenderer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports